export const INTERACTIVE_SERVICE_BASE_URL = 'interactive-service';

export const MESSAGE_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant',
    SYSTEM: 'system',
};

export const STEP_STATUS = {
    PENDING: 'pending',
    RUNNING: 'running',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export const ERROR_TYPES = {
    ERROR: 'report_error',
    USER_ERROR: 'report_user_error',
};

export const EVENT_TYPES = {
    // Lifecycle events
    STARTED: 'report_generation_started',
    COMPLETED: 'report_generation_completed',
    CANCELLED: 'report_cancelled',
    ...ERROR_TYPES,
    // Content events
    TOKEN: 'token',
    TOKEN_BATCH: 'token_batch',
    STEP_UPDATE: 'step_update',
    ARTIFACT: 'data_artifact',

    RERUN_STARTED: 'report_rerun_started',

    RESPONSE_COMPLETE: 'response_complete',
    SESSION_TITLE_UPDATED: 'session_title_updated',

    // V2 AI SDK event types
    V2_START: 'start',
    V2_FINISH: 'finish',
    V2_TEXT_START: 'text-start',
    V2_TEXT_DELTA: 'text-delta',
    V2_TEXT_END: 'text-end',
    V2_REASONING_START: 'reasoning-start',
    V2_REASONING_DELTA: 'reasoning-delta',
    V2_REASONING_END: 'reasoning-end',
    V2_TOOL_INPUT_START: 'tool-input-start',
    V2_TOOL_INPUT_AVAILABLE: 'tool-input-available',
    V2_TOOL_OUTPUT_AVAILABLE: 'tool-output-available',
    V2_STEP_START: 'step-start',
    V2_STEP_FINISH: 'step-finish',
    V2_DATA_PREFIX: 'data-',
    V2_ERROR: 'error',
};

export const SESSION_TYPES = {
    CHAT: 'chat',
    DRILLDOWN: 'drilldown',
};

export const ARTIFACT_TYPES = {
    GRID: 'grid',
    TABLE: 'table',
    WIDGET: 'widget',
    MARKDOWN: 'markdown',
    CODE: 'code',
    ERROR: 'error',
};
